(function ($) {
  'use strict';

  $('#promo-articles a.btn-wlc').click(function (a) {
    a.preventDefault();
    var $section = $(this).parents('#promo-articles');
    var $moreVideos = $section.find('.more-promo-videos');

    $moreVideos.addClass('visible');
    $(this).hide();
  });
}).bind(window)(jQuery);
